import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {MCP_SERVER_ROUTE, mcpServerUrl} from '../../util/constants';
import {onSetCrumbs} from '../../util/events';
import McpServer from './mcpServer';

export default function McpServerController() {
    const {t} = useTranslation();
    const serverUrl = mcpServerUrl();

    useEffect(() => {
        onSetCrumbs([{label: t('mcpServer.crumb', 'Agent MCP'), route: MCP_SERVER_ROUTE}]);
    }, []);

    return <McpServer serverUrl={serverUrl} />;
}
